import script from "./TcNotification.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./TcNotification.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcNotification.vue?vue&type=script&setup=true&lang=ts"

import "./TcNotification.vue.scss?vue&type=style&index=0&id=1a8c1e43&lang=scss!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcNotification.vue?vue&type=style&index=0&id=1a8c1e43&lang=scss"

const __exports__ = script;

export default __exports__